import { Offcanvas } from 'react-bootstrap'
import CommonButton from '../components/commonButton';

const FilterDrower = ({ show, handleClose, title = "Filter", onClear, onSubmit, props, children }) => {
    return (
        <Offcanvas show={show} onHide={handleClose} placement='end' {...props}>
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{title}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {children}
            </Offcanvas.Body>
            <div className="d-flex justify-content-end gap-2 px-3 py-3 border-top">
                {onClear && (
                    <CommonButton
                        variant="outline"
                        className='px-4'
                        onClick={onClear}
                        title="Clear All"
                    />
                )}
                {onSubmit && (
                    <CommonButton
                        variant="primary"
                        className="px-4"
                        onClick={onSubmit}
                        title="Apply"
                    />
                )}
            </div>
        </Offcanvas>
    )
}

export default FilterDrower